import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ThemeService } from './theme.service';
import { ApplicationConfigService } from './application-config.service';
import { ApiProviderService } from './api-provider.service';
import { mapAsBody } from '../app/shared/util/request-util';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ThemeView } from '../models/theme-view.model';

type EntityResponseType = HttpResponse<ThemeView>;

@Injectable({ providedIn: 'root' })
export class ThemeExtendedService extends ThemeService {
  protected override resourceUrl = API_ENDPOINTS.THEME;

  constructor(private apiProvider: ApiProviderService, http: HttpClient, applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  getCurrentTheme(): Observable<ThemeView> {
    return this.apiProvider.publicGet<ThemeView>(this.resourceUrl, { observe: 'response' }).pipe(mapAsBody);
  }

  getCurrentThemeModerator(): Observable<ThemeView> {
    return this.apiProvider.get<ThemeView>(this.resourceUrl, { observe: 'response' }).pipe(mapAsBody);
  }

  override create(themeView: ThemeView): Observable<EntityResponseType> {
    return this.apiProvider.post<ThemeView>(this.resourceUrl, themeView, { observe: 'response' });
  }

  // update(themeView: ThemeView): Observable<EntityResponseType> {
  //   return this.apiProvider.put<ThemeView>(this.resourceUrl, themeView,{ observe: 'response' });
  // }
}
